// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { espotCardStyles } from "@tps/App/Widgets/EspotWidget/EspotCard";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

espotCardStyles.wrapper = {
    css: css`
        padding: 32px;
        width: 100%;
        display: flex;
        flex-direction: column;
        ${({ backgroundColor }: any) => {
            if (backgroundColor) {
                return css`
                    background: ${backgroundColor};
                `;
            }
        }}
        ${({ padding, mobilePadding }: any) => {
            return css`
                padding-inline: ${padding}px;
                ${xScreen("lt", "sm")} {
                    padding-inline: ${mobilePadding}px;
                }
            `;
        }}
        ${({ borderColor, borderSide }: any) => {
            if (!borderColor) {
                return;
            }
            const responsiveBorderSide = borderSide === "left" ? "top" : "bottom";
            return css`
                border-${borderSide}: 1px solid ${borderColor};
                ${xScreen("lte", "md")} {
                    border-${borderSide}: none;
                    border-${responsiveBorderSide}: 1px solid ${borderColor};
                }
            `;
        }}
    `,
};
espotCardStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 16px;
        ${TypographyStyle} {
            margin-bottom: 0;
            font-size: 24px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 32px;
        }
    `,
};
espotCardStyles.description = {
    variant: "p",
    css: css`
        margin-bottom: 20px;
        ${TypographyStyle} {
            margin-bottom: 0;
        }
    `,
};
espotCardStyles.buttonWrapper = {
    css: css`
        width: auto;
    `,
};
